import { useCallback, useEffect, useRef, useState } from "react";
import { api, errMsg } from "../../lib/api";

const KEY = "dp_folha_ref";
const today = () => { const n = new Date(); return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}`; };

// Shared competência (sessionStorage) + silent 15s polling, used by Movimentações mensais and Folha.
export function useFolhaMonth() {
  const [ref, setRefState] = useState(sessionStorage.getItem(KEY) || today());
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const seq = useRef(0);
  const load = useCallback((silent) => {
    const id = ++seq.current;
    return api.get(`/folha/month/${ref}`, { silent }).then((x) => { if (id === seq.current) { setD(x.data); setErr(""); } })
      .catch((e) => { if (!silent && id === seq.current) setErr(errMsg(e)); });
  }, [ref]);
  useEffect(() => {
    load(false);
    const t = setInterval(() => document.visibilityState === "visible" && load(true), 15000);
    window.addEventListener("focus", load);
    return () => { clearInterval(t); window.removeEventListener("focus", load); };
  }, [load]);
  const setRef = (r) => { sessionStorage.setItem(KEY, r); setD(null); setRefState(r); };
  return { ref, d: d && d.ref === ref ? d : null, err, load, setRef };
}
